module.exports = __webpack_public_path__ + "media/images/product-img-02-84455ff5316696d24581bf2cdfc80840.jpg";